//TODO: Este documento pertenece al nuevo flujo de paquetes mayoristas

import { deleteCiudadPaqueteTerrestreById, deleteExtraPaqueteTerrestreById, deleteHotelPaqueteTerrestreById, deletePlazaPaqueteTerrestreById, getCircuitosIdProveedorTerrestre, getCiudadPaqueteTerrestreById, getExtraPaqueteTerrestreById, getHotelPaqueteTerrestreById, getPlazaPaqueteTerrestreById, getProveedorTerrestreAll, getProveedorTerrestreLista, newCircuito, newProveedorTerrestre, newTipoExtraTerrestre, posPlazaPaqueteTerrestre, postCiudadPaqueteTerrestre, postExtraPaqueteTerrestre, postHotelPaqueteTerrestre, postPlazaPaqueteTerrestre, updateProveedorTerrestre } from "../services/packageService";
import { getProveedoresTerrestresCatalogo } from "../services/supplierService";
import { FormatoFecha } from "../utils/FormatFecha";

const dataInicial = {
    arrayTerrestre: [],
    totalArrayTerrestre: 0,
    catalogoTerrestre: [],
    exito: 0,
    provedorCircuito: {},
    openCirutoAlta: false,
    arrayCircuitos: [],
    pagina: 0,
    regisitros: 10,
    filtroProveedor: "NA",
    listaPaqueteTerrestres: [],
    openEditPaquete: false,
    paqueteSelect: {},
    listaHoteletesTerrestre: [],
    listaPlazasTerrestre: [],
    listaCiudadesTerrestre: [],
    listaExtrasTerrestre: [],
    openHotelTerrestre: false,
    openPlazaTerrestre: false,
    openCiudadTerrestre: false,
    openExtraTerrestre: false
}

const OBTENER_TERRESTRE_ALL_ACTION = "OBTENER_TERRESTRE_ALL_ACTION"
const OBTENER_TERRESTRE_PAGINA_ACTION = "OBTENER_TERRESTRE_PAGINA_ACTION"
const OBTENER_TERRESTRE_REGISTROS_ACTION = "OBTENER_TERRESTRE_REGISTROS_ACTION"
const OBTENER_TERRESTRE_PROVEEDOR_ACTION = "OBTENER_TERRESTRE_PROVEEDOR_ACTION"
const NUEVO_TERRESTRE_ACTION = "NUEVO_TERRESTRE_ACTION"
const ACTUALIZAR_TERRESTRE_ACTION = "ACTUALIZAR_TERRESTRE_ACTION"
const OBTENER_TERRESTRE_PROVEDORES_CATALOGO_ACTION = "OBTENER_TERRESTRE_PROVEDORES_CATALOGO_ACTION"
const NUEVO_TERRESTRE_CIRCUITO_ACTION = "NUEVO_TERRESTRE_CIRCUITO_ACTION"
const OPEN_TERRESTRE_CIRCUITO_ACTION = "OPEN_TERRESTRE_CIRCUITO_ACTION"
const OBTENER_TERRESTRE_CIRUCUITOS_ID_ACTION = "OBTENER_TERRESTRE_CIRUCUITOS_ID_ACTION"
const OBTENER_TERRESTRE_ALL_CATALOGO_ACTION = "OBTENER_TERRESTRE_ALL_CATALOGO_ACTION"
const OPEN_TERRESTRE_EDITAR_PAQUETE_ACTION = "OPEN_TERRESTRE_EDITAR_PAQUETE_ACTION"
const NUEVO_TERRESTRE_PAQUETE_HOTEL = "NUEVO_TERRESTRE_PAQUETE_HOTEL"
const OBTENER_TERRESTRE_PAQUETE_HOTEL = "OBTENER_TERRESTRE_PAQUETE_HOTEL"
const ELIMANR_TERRESTRE_PAQUETE_HOTEL = "ELIMANR_TERRESTRE_PAQUETE_HOTEL"
const NUEVO_TERRESTRE_PAQUETE_PLAZA = "NUEVO_TERRESTRE_PAQUETE_PLAZA"
const OBTENER_TERRESTRE_PAQUETE_PLAZA = "OBTENER_TERRESTRE_PAQUETE_PLAZA"
const ELIMANR_TERRESTRE_PAQUETE_PLAZA = "ELIMANR_TERRESTRE_PAQUETE_PLAZA"
const NUEVO_TERRESTRE_PAQUETE_CIUDAD = "NUEVO_TERRESTRE_PAQUETE_CIUDAD"
const OBTENER_TERRESTRE_PAQUETE_CIUDAD = "OBTENER_TERRESTRE_PAQUETE_CIUDAD"
const ELIMANR_TERRESTRE_PAQUETE_CIUDAD = "ELIMANR_TERRESTRE_PAQUETE_CIUDAD"
const NUEVO_TERRESTRE_PAQUETE_EXTRA = "NUEVO_TERRESTRE_PAQUETE_EXTRA"
const OBTENER_TERRESTRE_PAQUETE_EXTRA = "OBTENER_TERRESTRE_PAQUETE_EXTRA"
const ELIMANR_TERRESTRE_PAQUETE_EXTRA = "ELIMANR_TERRESTRE_PAQUETE_EXTRA"
const OPEN_TERRESTRE_HOTEL_ACTION = "OPEN_TERRESTRE_HOTEL_ACTION"
const OPEN_TERRESTRE_PLAZA_ACTION = "OPEN_TERRESTRE_PLAZA_ACTION"
const OPEN_TERRESTRE_CIUDAD_ACTION = "OPEN_TERRESTRE_CIUDAD_ACTION"
const OPEN_TERRESTRE_EXTRA_ACTION = "OPEN_TERRESTRE_EXTRA_ACTION"
const NUEVO_TERRESTRE_EXTRA_TIPO_ACTION = "NUEVO_TERRESTRE_EXTRA_TIPO_ACTION"

export default function proveedorTerrestreReducer(state = dataInicial, action) {
    if (action.type === OPEN_TERRESTRE_HOTEL_ACTION) {
        return { ...state, openHotelTerrestre: action.payload.openHotelTerrestre, paqueteSelect: action.payload.paqueteSelect  }
    }
    if (action.type === OPEN_TERRESTRE_PLAZA_ACTION) {
        return { ...state, openPlazaTerrestre: action.payload.openPlazaTerrestre, paqueteSelect: action.payload.paqueteSelect }
    }
    if (action.type === OPEN_TERRESTRE_CIUDAD_ACTION) {
        return { ...state, openCiudadTerrestre: action.payload.openCiudadTerrestre, paqueteSelect: action.payload.paqueteSelect }
    }
    if (action.type === OPEN_TERRESTRE_EXTRA_ACTION) {
        return { ...state, openExtraTerrestre: action.payload.openExtraTerrestre, paqueteSelect: action.payload.paqueteSelect }
    }
    if (action.type === OBTENER_TERRESTRE_PAQUETE_EXTRA) {
        return { ...state, listaExtrasTerrestre: action.payload.listaExtrasTerrestre }
    }
    if (action.type === OBTENER_TERRESTRE_PAQUETE_CIUDAD) {
        return { ...state, listaCiudadesTerrestre: action.payload.listaCiudadesTerrestre }
    }
    if (action.type === OBTENER_TERRESTRE_PAQUETE_PLAZA) {
        return { ...state, listaPlazasTerrestre: action.payload.listaPlazasTerrestre }
    }
    if (action.type === OBTENER_TERRESTRE_PAQUETE_HOTEL) {
        return { ...state, listaHoteletesTerrestre: action.payload.listaHoteletesTerrestre }
    }
    if (action.type === OPEN_TERRESTRE_EDITAR_PAQUETE_ACTION) {
        return { ...state, openEditPaquete: action.payload.openEditPaquete, paqueteSelect: action.payload.paqueteSelect }
    }
    if (action.type === OBTENER_TERRESTRE_ALL_CATALOGO_ACTION) {
        return { ...state, listaPaqueteTerrestres: action.payload.listaPaqueteTerrestres }
    }
    if (action.type === OBTENER_TERRESTRE_ALL_ACTION) {
        return {
            ...state,
            arrayTerrestre: action.payload.arrayTerrestre,
            totalArrayTerrestre: action.payload.totalArrayTerrestre,
        }
    }
    if (action.type === OBTENER_TERRESTRE_PAGINA_ACTION) {
        return {
            ...state,
            arrayTerrestre: action.payload.arrayTerrestre,
            totalArrayTerrestre: action.payload.totalArrayTerrestre,
            pagina: action.payload.pagina,
        }
    }
    if (action.type === OBTENER_TERRESTRE_REGISTROS_ACTION) {
        return {
            ...state,
            arrayTerrestre: action.payload.arrayTerrestre,
            totalArrayTerrestre: action.payload.totalArrayTerrestre,
            regisitros: action.payload.regisitros,
        }
    }
    if (action.type === OBTENER_TERRESTRE_PROVEEDOR_ACTION) {
        return {
            ...state,
            arrayTerrestre: action.payload.arrayTerrestre,
            totalArrayTerrestre: action.payload.totalArrayTerrestre,
            regisitros: action.payload.regisitros,
            pagina: action.payload.pagina,
            filtroProveedor: action.payload.filtroProveedor
        }
    }
    if (action.type === OBTENER_TERRESTRE_CIRUCUITOS_ID_ACTION) {
        return {
            ...state,
            arrayCircuitos: action.payload.arrayCircuitos
        }
    }
    if (action.type === OPEN_TERRESTRE_CIRCUITO_ACTION) {
        return {
            ...state,
            provedorCircuito: action.payload.provedorCircuito,
            openCirutoAlta: action.payload.openCirutoAlta,
        }
    }
    if (action.type === OBTENER_TERRESTRE_PROVEDORES_CATALOGO_ACTION) {
        return {
            ...state,
            catalogoTerrestre: action.payload.catalogoTerrestre
        }
    }
    if (action.type === NUEVO_TERRESTRE_ACTION ||
        action.type === ACTUALIZAR_TERRESTRE_ACTION ||
        action.type === NUEVO_TERRESTRE_CIRCUITO_ACTION ||
        action.type === NUEVO_TERRESTRE_PAQUETE_HOTEL ||
        action.type === ELIMANR_TERRESTRE_PAQUETE_HOTEL ||
        action.type === NUEVO_TERRESTRE_PAQUETE_PLAZA ||
        action.type === ELIMANR_TERRESTRE_PAQUETE_PLAZA ||
        action.type === NUEVO_TERRESTRE_PAQUETE_CIUDAD ||
        action.type === ELIMANR_TERRESTRE_PAQUETE_CIUDAD ||
        action.type === NUEVO_TERRESTRE_PAQUETE_EXTRA ||
        action.type === ELIMANR_TERRESTRE_PAQUETE_EXTRA ||
        action.type === NUEVO_TERRESTRE_EXTRA_TIPO_ACTION     ) {
        return {
            ...state,
            exito: action.payload.exito
        }
    }
    return state;
}

//* Metodos de para terrestre
export const obtenerTerrestreAllListaAction = () => async (dispatch) => {
    return await getProveedorTerrestreLista().then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_ALL_CATALOGO_ACTION,
            payload: {
                listaPaqueteTerrestres: Response
            }
        })
        return Response
    })
}
export const obtenerTerrestreAllAction = () => async (dispatch, getState) => {
    const { regisitros, pagina, filtroProveedor } = getState().proveedorTerrestre
    return await getProveedorTerrestreAll({ idProveedor: filtroProveedor, Pagina: pagina + 1, Registros: regisitros }).then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_ALL_ACTION,
            payload: {
                arrayTerrestre: Response.LPaqueteProveedorTerrestre,
                totalArrayTerrestre: Response.Total,
            }
        })
        return Response
    })
}
export const obtenerTerrestrePaginaAction = ({ pagina }) => async (dispatch, getState) => {
    const { regisitros, filtroProveedor } = getState().proveedorTerrestre
    return await getProveedorTerrestreAll({ idProveedor: filtroProveedor, Pagina: pagina + 1, Registros: regisitros }).then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_PAGINA_ACTION,
            payload: {
                arrayTerrestre: Response.LPaqueteProveedorTerrestre,
                totalArrayTerrestre: Response.Total,
                pagina: pagina
            }
        })
        return Response
    })
}
export const obtenerTerrestreRegistrosAction = ({ regisitros }) => async (dispatch, getState) => {
    const { pagina, filtroProveedor } = getState().proveedorTerrestre
    return await getProveedorTerrestreAll({ idProveedor: filtroProveedor, Pagina: pagina + 1, Registros: regisitros }).then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_REGISTROS_ACTION,
            payload: {
                arrayTerrestre: Response.LPaqueteProveedorTerrestre,
                totalArrayTerrestre: Response.Total,
                regisitros: regisitros,
            }
        })
        return Response
    })
}
export const obtenerTerrestreFiltroProveedorAction = ({ idProveedor }) => async (dispatch, getState) => {
    const { pagina, regisitros } = dataInicial
    return await getProveedorTerrestreAll({ idProveedor: idProveedor, Pagina: pagina + 1, Registros: regisitros }).then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_ALL_ACTION,
            payload: {
                arrayTerrestre: Response.LPaqueteProveedorTerrestre,
                totalArrayTerrestre: Response.Total,
                pagina: pagina,
                regisitros: regisitros,
                filtroProveedor: idProveedor,
            }
        })
        return Response
    })
}
export const obtenerCatalogoProveedorTerrestre = () => async (dispatch) => {
    return await getProveedoresTerrestresCatalogo().then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_PROVEDORES_CATALOGO_ACTION,
            payload: {
                catalogoTerrestre: Response
            }
        })
    })
}
export const crearTerrestreAction = ({ ClavePaquete, IdMoneda, IdProveedor, Itinerario, Nombre, PrecioNeto, Incluye, NoIncluye }) => async (dispatch) => {
    return await newProveedorTerrestre({ ClavePaquete, IdMoneda, IdProveedor, Itinerario, Nombre, PrecioNeto, Incluye, NoIncluye }).then(Response => {
        dispatch({
            type: NUEVO_TERRESTRE_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const actulizaTerrestreAction = ({ IdPaqueteProveedorTerrestre, ClavePaquete, Estatus, IdMoneda, IdProveedor, Incluye, Itinerario, NoIncluye, Nombre, PrecioNeto }) => async (dispatch) => {
    return await updateProveedorTerrestre({ IdPaqueteProveedorTerrestre, ClavePaquete, Estatus, IdMoneda, IdProveedor, Incluye, Itinerario, NoIncluye, Nombre, PrecioNeto }).then(Response => {
        dispatch({
            type: ACTUALIZAR_TERRESTRE_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const openModalEditarPaqueteAction = ({ open, paquete }) => (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_EDITAR_PAQUETE_ACTION,
        payload: {
            openEditPaquete: open,
            paqueteSelect: paquete
        }
    })
}

// * Metodos para crear circuitos 
export const obtenerCicuitosProvedor = ({ id }) => async (dispatch) => {
    return await getCircuitosIdProveedorTerrestre({ IdPaqueteProveedorTerrestre: id }).then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_CIRUCUITOS_ID_ACTION,
            payload: {
                arrayCircuitos: Response
            }
        })
    })
}
export const crearCirucuitoAction = ({ ClaveCircuito, Disponibilidad, FechaFin, FechaInicio, id, Dias, Noches, Suplemento }) => async (dispatch) => {
    return await newCircuito({
        ClaveCircuito,
        Disponibilidad,
        FechaFin: FormatoFecha({ date: FechaFin, formato: "yyyy-MM-dd HH:MM" }),
        FechaInicio: FormatoFecha({ date: FechaInicio, formato: "yyyy-MM-dd HH:MM" }),
        IdPaqueteProveedorTerrestre: id,
        Dias,
        Noches,
        Suplemento,
    }).then(Response => {
        dispatch({
            type: NUEVO_TERRESTRE_CIRCUITO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const openMoadalAltaCiurcuito = ({ proveedor }) => async (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_CIRCUITO_ACTION,
        payload: {
            provedorCircuito: proveedor,
            openCirutoAlta: true
        }
    })
}
export const closeMoadalAltaCiurcuito = () => async (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_CIRCUITO_ACTION,
        payload: {
            provedorCircuito: dataInicial.provedorCircuito,
            openCirutoAlta: false
        }
    })
}

//* Metodos para manejo de hoteles paquetes
export const crearHotelPaqueteTerrestre = ({ idHotel, idPaqueteTerrestre, suplemento }) => async (dispatch) => {
    return await postHotelPaqueteTerrestre({ idHotel, idPaqueteTerrestre, suplemento }).then(Response => {
        dispatch({
            type: NUEVO_TERRESTRE_PAQUETE_HOTEL,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerHotelelesPaqueteTerrestre = ({ idPaqueteTerrestre }) => async (dispatch) => {
    return await getHotelPaqueteTerrestreById({ idPaqueteTerrestre }).then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_PAQUETE_HOTEL,
            payload: {
                listaHoteletesTerrestre: Response
            }
        })
        return Response
    }).catch(Error => Error)
}
export const eliminarHotelPaqueteTerrrestre = ({ idPaqueteTerrestreHotel }) => async (dispatch) => {
    return await deleteHotelPaqueteTerrestreById({ idPaqueteTerrestreHotel }).then(Response => {
        dispatch({
            type: ELIMANR_TERRESTRE_PAQUETE_HOTEL,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => Error)
}
export const openModalHotelPaqueteTerrestre = ({ paquete }) => (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_HOTEL_ACTION,
        payload: {
            openHotelTerrestre: true,
            paqueteSelect: paquete
        }
    })
}
export const closeModalHotelPaqueteTerrestre = () => (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_HOTEL_ACTION,
        payload: {
            openHotelTerrestre: false,
            paqueteSelect: dataInicial.paqueteSelect
        }
    })
}

//* Metodos para manejo de plazas paquetes
export const crearPlazaPaqueteTerrestre = ({ disponibilidad, idTipoPlaza, idPaqueteTerrestre, suplemento }) => async (dispatch) => {
    return await postPlazaPaqueteTerrestre({ disponibilidad, idPaqueteTerrestre, idTipoPlaza, suplemento }).then(Response => {
        dispatch({
            type: NUEVO_TERRESTRE_PAQUETE_PLAZA,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error =>{
        return Error
    })
}
export const obtenerPLazasPaqueteTerrestre = ({ idPaqueteTerrestre }) => async (dispatch) => {
    return await getPlazaPaqueteTerrestreById({ idPaqueteTerrestre }).then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_PAQUETE_PLAZA,
            payload: {
                listaPlazasTerrestre: Response
            }
        })
        return Response
    }).catch(Error => Error)
}
export const eliminarPlazaPaqueteTerrrestre = ({ idPaqueteTerrestrePlaza }) => async (dispatch) => {
    return await deletePlazaPaqueteTerrestreById({ idPaqueteTerrestrePlaza }).then(Response => {
        dispatch({
            type: ELIMANR_TERRESTRE_PAQUETE_PLAZA,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => Error)
}
export const openModalPlazaPaqueteTerrestre = ({ paquete }) => (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_PLAZA_ACTION,
        payload: {
            openPlazaTerrestre: true,
            paqueteSelect: paquete
        }
    })
}
export const closeModalPlazaPaqueteTerrestre = () => (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_PLAZA_ACTION,
        payload: {
            openPlazaTerrestre: false,
            paqueteSelect: dataInicial.paqueteSelect
        }
    })
}

//* Metodos para manejo de ciudades paquetes
export const crearCiudadPaqueteTerrestre = ({ idCiudad, idPaqueteTerrestre }) => async (dispatch) => {
    return await postCiudadPaqueteTerrestre({ idCiudad, idPaqueteTerrestre }).then(Response => {
        dispatch({
            type: NUEVO_TERRESTRE_PAQUETE_CIUDAD,
            payload: {
                exito: 1
            }
        })
    }).catch(Error => Error)
}
export const obtenerCiudadesPaqueteTerrestre = ({ idPaqueteTerrestre }) => async (dispatch) => {
    return await getCiudadPaqueteTerrestreById({ idPaqueteTerrestre }).then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_PAQUETE_CIUDAD,
            payload: {
                listaCiudadesTerrestre: Response
            }
        })
        return Response
    }).catch(Error => Error)
}
export const eliminarCiudadPaqueteTerrrestre = ({ idPaqueteTerrestreCiudad }) => async (dispatch) => {
    return await deleteCiudadPaqueteTerrestreById({ idPaqueteTerrestreCiudad }).then(Response => {
        dispatch({
            type: ELIMANR_TERRESTRE_PAQUETE_CIUDAD,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => Error)
}
export const openModalCiudadesPaqueteTerrestre = ({ paquete }) => (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_CIUDAD_ACTION,
        payload: {
            openCiudadTerrestre: true,
            paqueteSelect: paquete
        }
    })
}
export const closeModalCiudadesPaqueteTerrestre = () => (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_CIUDAD_ACTION,
        payload: {
            openCiudadTerrestre: false,
            paqueteSelect: dataInicial.paqueteSelect
        }
    })
}

//* Metodos para manejo de extras paquetes
export const crearExtraPaqueteTerrestre = ({ descripcion, idExtra, idPaqueteTerrestre, suplemento }) => async (dispatch) => {
    return await postExtraPaqueteTerrestre({ descripcion, idExtra, idPaqueteTerrestre, suplemento }).then(Response => {
        dispatch({
            type: NUEVO_TERRESTRE_PAQUETE_EXTRA,
            payload: {
                exito: 1
            }
        })
    }).catch(Error => Error)
}
export const obtenerExtrasPaqueteTerrestre = ({ idPaqueteTerrestre }) => async (dispatch) => {
    return await getExtraPaqueteTerrestreById({ idPaqueteTerrestre }).then(Response => {
        dispatch({
            type: OBTENER_TERRESTRE_PAQUETE_EXTRA,
            payload: {
                listaExtrasTerrestre: Response
            }
        })
        return Response
    }).catch(Error => Error)
}
export const eliminarExtraPaqueteTerrrestre = ({ idPaqueteTerrestreExtra }) => async (dispatch) => {
    return await deleteExtraPaqueteTerrestreById({ idPaqueteTerrestreExtra }).then(Response => {
        dispatch({
            type: ELIMANR_TERRESTRE_PAQUETE_EXTRA,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => Error)
}
export const openModalExtrasPaqueteTerrestre = ({ paquete }) => (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_EXTRA_ACTION,
        payload: {
            openExtraTerrestre: true,
            paqueteSelect: paquete
        }
    })
}
export const closeModalExtrasPaqueteTerrestre = () => (dispatch) => {
    dispatch({
        type: OPEN_TERRESTRE_EXTRA_ACTION,
        payload: {
            openExtraTerrestre: false,
            paqueteSelect: dataInicial.paqueteSelect
        }
    })
}
export const actualizaTipoExtraTerrestreAction = ({ idCatExtra, idExtra, imagen, extencion }) => async (dispatch) => {
    return await newTipoExtraTerrestre({ idCatExtra, idExtra, imagen, extencion }).then(Response => {
        dispatch({
            type: NUEVO_TERRESTRE_EXTRA_TIPO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
